import { render, staticRenderFns } from "./ProfileAppointmentDefault.vue?vue&type=template&id=0f566eff&scoped=true&"
import script from "./ProfileAppointmentDefault.vue?vue&type=script&lang=js&"
export * from "./ProfileAppointmentDefault.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAppointmentDefault.vue?vue&type=style&index=0&id=0f566eff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f566eff",
  null
  
)

export default component.exports